var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3131_12375)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M18.5 20.25V3.75C18.5 2.92157 17.8284 2.25 17 2.25L8 2.25C7.17157 2.25 6.5 2.92157 6.5 3.75L6.5 20.25C6.5 21.0784 7.17157 21.75 8 21.75H17C17.8284 21.75 18.5 21.0784 18.5 20.25Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 1.5H8C7.40402 1.50247 6.83316 1.74031 6.41174 2.16174C5.99031 2.58316 5.75247 3.15402 5.75 3.75V20.25C5.75247 20.846 5.99031 21.4168 6.41174 21.8383C6.83316 22.2597 7.40402 22.4975 8 22.5H17C17.596 22.4975 18.1668 22.2597 18.5883 21.8383C19.0097 21.4168 19.2475 20.846 19.25 20.25V3.75C19.2475 3.15402 19.0097 2.58316 18.5883 2.16174C18.1668 1.74031 17.596 1.50247 17 1.5ZM17.75 20.25C17.75 20.4489 17.671 20.6397 17.5303 20.7803C17.3897 20.921 17.1989 21 17 21H8C7.80109 21 7.61032 20.921 7.46967 20.7803C7.32902 20.6397 7.25 20.4489 7.25 20.25V3.75C7.25 3.55109 7.32902 3.36032 7.46967 3.21967C7.61032 3.07902 7.80109 3 8 3H17C17.1989 3 17.3897 3.07902 17.5303 3.21967C17.671 3.36032 17.75 3.55109 17.75 3.75V20.25Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5 4.5H9.5C9.30109 4.5 9.11032 4.57902 8.96967 4.71967C8.82902 4.86032 8.75 5.05109 8.75 5.25C8.75 5.44891 8.82902 5.63968 8.96967 5.78033C9.11032 5.92098 9.30109 6 9.5 6H15.5C15.6989 6 15.8897 5.92098 16.0303 5.78033C16.171 5.63968 16.25 5.44891 16.25 5.25C16.25 5.05109 16.171 4.86032 16.0303 4.71967C15.8897 4.57902 15.6989 4.5 15.5 4.5Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3131_12375"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserPhone);
export default __webpack_public_path__ + "static/media/user_phone.c9947b29355900d13debd1c9e3cdce4b.svg";
export { ForwardRef as ReactComponent };